import { useQuery } from 'react-query'
import { getAuthProfile } from 'services/auth'

export default function useGetProfile() {
    const { data: profileData, isLoading } = useQuery(
        ['auth-profile'],
        getAuthProfile
    )
    return { profileData, isLoading }
}
